export enum PoliciesEnum {
  GENERAL_TERMS_CONDITION = 'GENERAL_TERMS_CONDITION',
  CONFIDENTIALITY_POLICY = 'CONFIDENTIALITY_POLICY',
}

export interface Policy {
  link: string;
  type: PoliciesEnum;
}
